export class LoadStudentByNameAction {
  static readonly type = '[Student] Set Student By Name';
  constructor(public payload: string) {}
}
